import { formatPrice } from './tool';
import intlPrice from './intlPrice';
import convert from './convert';

const displayPrice = (
    business,
    nb,
    lang,
    currentCurrency,
    originalCurrency,
    currencies = false,
    convertPrice = false,
) => {
    let price = nb;

    if (currencies && convertPrice && currencies.length > 0) {
        price = convert(price, currentCurrency, originalCurrency, currencies);
    }

    price = formatPrice(price, currentCurrency, originalCurrency);

    price = intlPrice(business, price, lang, currentCurrency);

    return price;
};

export default displayPrice;
